import React, { Component } from 'react'
import { Form, FormInstance, Input, Select, Switch } from 'antd'
import { CharacteristicsProvider, CharacteristicsConsumer, CharacteristicsContextData } from '../../../../context/CharacteristicsContext'
import { ShelterProvider, ShelterConsumer, ShelterContextData } from '../../../../context/ShelterContext'
import { PartnerKeyType } from 'interfaces/IIntegration'
import { sbListIcon } from 'services/integration'
import { IntegrationProvider } from 'context/IntegrationContext'
import { DEFAULT_SELECT_FILTER_OPTION } from 'helpers/form-fields.helper'

type MappingCharacteristicProps = {
  form: FormInstance
  partnerList: any[]
}
export default class MappingCharacteristicForm extends Component<MappingCharacteristicProps> {

  // FIXME: hack to make the form refresh after form values changes
  onValuesChange(changes: any, all: any) {
    // console.log("[changed]", changes)
    const keys = Object.keys(changes)
    if (keys.some(v => v.match(/partner_key|integration_uuid|shelter_uuid/))) {
      this.forceUpdate()
    }
  }

  render() {
    const partnerList = this.props.partnerList?.filter(v => v.key === "SHELTER_BUDDY") // only available for SHELTER_BUDDY now 
    const currentPartnerKey = this.props.form.getFieldValue("partner_key")

    return (
      <CharacteristicsProvider>
        <ShelterProvider>
          <IntegrationProvider>
            <CharacteristicsConsumer>
              {(characteristicsContext) => (
                <ShelterConsumer>
                  {(shelterContext) =>
                    <MappingCharacteristicFormInternal
                      form={this.props.form}
                      shelterContext={shelterContext}
                      characteristicsContext={characteristicsContext}
                      partnerKey={currentPartnerKey}
                      partnerList={partnerList}
                    />
                  }
                </ShelterConsumer>
              )}
            </CharacteristicsConsumer>
          </IntegrationProvider>
        </ShelterProvider>
      </CharacteristicsProvider>
    )
  }
}

type MappingCharacteristicInternalProps = MappingCharacteristicProps & {
  shelterContext: ShelterContextData
  characteristicsContext: CharacteristicsContextData
  partnerKey: PartnerKeyType
}
class MappingCharacteristicFormInternal extends Component<MappingCharacteristicInternalProps> {
  state = {
    fetching: false,
    integrationUuid: undefined,
    externalList: undefined,
    shelter_uuid: undefined,
  }

  componentDidMount() {
    const { shelterContext, characteristicsContext } = this.props

    if (!shelterContext.fetching && !shelterContext.shelters?.length) {
      shelterContext.requestShelterList({
        options: {
          limit: 9999
        },
        search: {
          _fields: ["id", "uuid", "name"],
          active: true,
          deleted: false,
          organization_integrations: {
            with: {
              _fields: ["id", "uuid", "description", "partner_key", "main", "shelter_id"],
              active: true,
              deleted: false,
            }
          }
        }
      })
    }

    if (!characteristicsContext.fetching && !characteristicsContext.characteristicsRaw) {
      characteristicsContext.requestCharacteristics()
    }
  }

  render() {
    const partnerOptions = this.props.partnerList?.map(partner => {
      return {
        label: partner.name || partner.key,
        value: partner.key
      }
    })

    const characteristicOptions = this.props.characteristicsContext.characteristicsRaw?.map(characteristic => {
      return {
        label: characteristic.name,
        value: characteristic.uuid
      }
    })

    const shelterOptions = this.props.shelterContext.shelters?.map(shelter => {
      return {
        label: shelter.name,
        value: shelter.uuid
      }
    })

    const shelterUuid = this.props.form.getFieldValue("shelter_uuid")
    const integrationList = this.props.shelterContext.shelters?.find(shelter => shelter.uuid === shelterUuid)?.organization_integrations?.filter(v => v.partner_key === this.props.partnerKey)

    const integrationOptions = integrationList?.map(v => ({
      label: `${v.main ? "(MAIN) " : ""}${v.description || ""} - ${v.uuid}`,
      value: v.uuid,
    }))

    const mainIntegrationUuid = integrationList?.find(v => v.main)?.uuid

    return (
      <>
        <Form.Item
          label="Partner"
          name="partner_key"
          rules={[
            {
              required: true,
              message: 'Missing a partner'
            }
          ]}
        >
          <Select
            placeholder="Select a partner"
            options={partnerOptions}
          />
        </Form.Item>
        <Form.Item
          label="Characteristic"
          name="characteristic_uuid"
          rules={[
            {
              required: true,
              message: 'Missing characteristic'
            }
          ]}
        >
          <Select
            loading={this.props.characteristicsContext.fetching}
            placeholder="Select a characteristic"
            options={characteristicOptions}
            showSearch={true}
            filterOption={DEFAULT_SELECT_FILTER_OPTION}
          />
        </Form.Item>
        <Form.Item
          label="Shelter"
          name="shelter_uuid"
          rules={[
            {
              required: true,
              message: 'Missing shelter'
            }
          ]}
        >
          <Select
            loading={this.props.shelterContext.fetching}
            placeholder="Select a shelter"
            options={shelterOptions}
            showSearch={true}
            filterOption={DEFAULT_SELECT_FILTER_OPTION}
          />
        </Form.Item>

        <Form.Item
          label="Integration (only to load external list)"
          name="integration_uuid"
          initialValue={mainIntegrationUuid}
        >
          <Select
            placeholder="Select an integration"
            options={integrationOptions}
            showSearch={true}
            filterOption={DEFAULT_SELECT_FILTER_OPTION}
          />
        </Form.Item>

        {this.renderExternal(this.props.form.getFieldValue("integration_uuid"))}

        <Form.Item
          label="Active"
          name="active"
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>
      </>
    )
  }

  renderExternal(integrationUuid: string) {
    if (this.props.partnerKey !== "SHELTER_BUDDY") {
      return <h1 style={{ color: "red" }}>[SELECT A VALID PARTNER KEY]</h1>
    } else {
      if (!this.state.fetching && integrationUuid && integrationUuid !== this.state.integrationUuid) {
        // FIXME: this is not the right way to load data (render)
        this.loadExternalMapping(integrationUuid, () => {
          // for some reason antd is not updating the label after the options is loaded
          const external_id = this.props.form.getFieldValue("external_id")?.toString()
          this.props.form.setFieldsValue({ external_id })
        })
      }

      return (
        <>
          <Form.Item
            label="External"
            name="external_id"
            rules={[
              {
                required: true,
                message: 'Missing external mapping'
              }
            ]}
          >
            <Select
              loading={this.state.fetching}
              placeholder="Select an icon"
              options={this.state.externalList}
              showSearch={true}
              filterOption={DEFAULT_SELECT_FILTER_OPTION}
              onSelect={(value, option) => {
                this.props.form.setFieldsValue({ name: option.name })
              }}
            />
          </Form.Item>
          <Form.Item
            hidden
            label="Name"
            name="name"
            rules={[
              {
                required: true,
                message: 'Missing external mapping'
              }
            ]}
          >
            <Input />
          </Form.Item>

        </>)
    }
  }

  loadExternalMapping(integrationUuid: string, onComplete?: () => void) {
    this.setState({ fetching: true, integrationUuid }, async () => {
      const external = await sbListIcon({ integration_uuid: integrationUuid })

      if (external.data.status !== 200) {
        console.error(external.data)
        this.setState({ fetching: false, externalList: undefined })
      } else {
        const externalList = external.data.data?.map(v => ({
          label: `${v.Name} [${v.Id}]`,
          name: v.Name,
          value: v.Id.toString(),
        }))

        this.setState({ fetching: false, externalList }, onComplete)
      }
    })
  }
}
